import { Divider, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles(theme => ({
  flex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  divider: {
    flexGrow: 1,
  },
  title: {
    color: theme.palette.text.secondary,
    padding: '0 8px',
  },
}));

interface DqDividerProps {
  title: string;
}

export const DqDivider: React.FC<DqDividerProps> = props => {
  const classes = useStyles();

  return (
    <div className={classes.flex}>
      <Divider className={classes.divider} />
      <Typography className={classes.title}>{props.title}</Typography>
      <Divider className={classes.divider} />
    </div>
  );
};
